import { render, staticRenderFns } from "./myWalletComponent.vue?vue&type=template&id=9582f028"
import script from "./myWalletComponent.vue?vue&type=script&lang=js"
export * from "./myWalletComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports